<template>
    <div class="contact-us_block margin-t-2">
        <label class="text-s text-color-weak" :for="field.name">{{ field.label }}</label>
        <div>
            <input :id="field.name" type="text" :name="field.name" v-model="field.value" :required="field.required">
        </div>
        <p v-if="!field.isValid" class="error">This field is required.</p>
    </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
    field: {
        type: Object,
        default: {}
    }
})

const isRequired = computed(() => {
    return props.field.required ? 'required' : ''

})

</script>
